import React, { useState, useContext } from "react";
import { Dialog } from "@headlessui/react";
import Carousel from "../components/UpdatedCarousel";
import PRODUCTS from "../../public/assets/products.json";
import { CartContext } from "../contexts/CartContext";
import { getCart } from "../utils/localstorage";
import { useNavigate } from "react-router-dom";
import Button from "./Button";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import VideoModal from "./VideoModal";

const B3Member = () => {
  const [confirmSubscribe, setConfirmSubscribe] = useState(undefined);
  const [hasSelected, setHasSelected] = useState(false);
  const cartContext = useContext(CartContext);
  const navigate = useNavigate();
  const [isMobileVideo, setIsMobileVideo] = useState(false);

  const memberProduct = {
    ...PRODUCTS.find((p) => p.Sku === "B3SubTD"),
  };

  const handleContinue = () => {
    const cart = getCart();
    const existingMemberSub = cart.find(
      (p) => p?.product?.Sku === memberProduct?.Sku
    );
    if (!existingMemberSub && confirmSubscribe) {
      cart.push({ product: memberProduct, qty: 1 });
    }
    cartContext.save(cart);
    navigate("/check-out");
  };

  return (
    <section className="container mx-auto flex-1 p-0 md:p-1 flex flex-col lg:max-w-full relative">
      <div className="flex flex-col">
        <div className="flex flex-col lg:flex-row gap-2 md:gap-10">
          <div className="flex items-center justify-center mb-4 pt-0 w-full lg:w-2/3 block md:hidden">
            <Carousel swiperImages={["B3U1.png", "B3U2.png", "B3U3.png"]} />
            <div className="mt-8 hidden md:block">
              <VideoModal
                open={isMobileVideo}
                setOpen={setIsMobileVideo}
                videoId="1045383546"
              />
            </div>
          </div>
          <div className="flex flex-col mb-2 mt-2 bg-[#302b2b] p-6 rounded-[1rem] w-full">
            <h1 className="pb-4 md:pb-0 text-[2.33rem] md:text-4xl roboto-medium">
              <span className="text-white">
                B<span className="text-[#00adef] mr-2">3</span>U Subscription
              </span>
              <br className="sm:hidden block" />
            </h1>
            <div className="hidden md:block w-full">
              <div className="roboto-regular">
                <p className="py-2 italic text-[#00adef] text-[1.3rem]">
                  Your First 30 Days Are FREE – Start Seeing Results Fast!
                </p>
                <ul className="list-disc pl-4 pb-2">
                  <li className="pt-1 text-xl text-white">
                    Access to over 200 live & on demand BFR workouts
                  </li>
                  <li className="pt-1 text-xl text-white">
                    Access to BFR masterclasses and educational series
                  </li>
                  <li className="pt-1 text-xl text-white">
                    Join a community focused on fitness, recovery & motivation
                  </li>
                </ul>
                <p className="text-[#00adef] text-lg  text-white">
                  After 30 days, your subscription will automatically renew at
                  $29.99/month. Cancel anytime.
                </p>
                <p className="pt-2 text-[#00adef] text-xl font-medium">
                  Please choose one to continue:
                </p>
                <div className="flex flex-col gap-2 md:mt-2">
                  <label className="grid grid-cols-[1.25rem_auto] items-start gap-3 cursor-pointer">
                    <input
                      type="radio"
                      name="b3u-subscription"
                      className="w-4 h-4 mt-2 accent-[#00adef]"
                      checked={confirmSubscribe === true}
                      onChange={() => {
                        setConfirmSubscribe(true);
                        setHasSelected(true);
                      }}
                    />
                    <span className="text-md leading-6 text-white">
                      Yes, I want my <strong>FREE 30-day B3 U trial</strong> and
                      full access to workouts, coaching, and community.
                    </span>
                  </label>

                  <label className="grid grid-cols-[1.25rem_auto] items-start gap-3 cursor-pointer">
                    <input
                      type="radio"
                      name="b3u-subscription"
                      className="w-4 h-4 mt-2 accent-[#00adef]"
                      checked={confirmSubscribe === false}
                      onChange={() => {
                        setConfirmSubscribe(false);
                        setHasSelected(true);
                      }}
                    />
                    <span className="text-md leading-6 text-white">
                      No, I do not want the Free 30 days on the{" "}
                      <strong>
                        B<span className="text-[#00adef]">3</span> U Fitness App
                      </strong>{" "}
                      and future monthly subscriptions. I agree to waive these
                      benefits and do not need the coaching, assistance,
                      inspiration and motivation.
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div className="md:hidden mx-auto w-full rounded-2xl shadow">
              <Disclosure>
                {({ open }) => (
                  <>
                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white px-4 py-2 text-left text-sm font-medium text-blue-900 hover:bg-white focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75">
                      <span className="text-lg roboto-bold text-[#00adef]">
                        Details
                      </span>
                      <ChevronUpIcon
                        className={`${
                          open ? "rotate-180 transform" : ""
                        } h-5 w-5 text-[#00adef] my-auto`}
                      />
                    </Disclosure.Button>
                    <Disclosure.Panel className="pt-4 pb-2 text-sm text-white">
                      <div className="block">
                        <div className="roboto-regular">
                          <p className="py-2 italic text-[#00adef] text-lg">
                            Your First 30 Days Are FREE – Start Seeing Results
                            Fast!
                          </p>
                          <ul className="list-disc pl-4 pb-2">
                            <li className="py-1 text-md text-white">
                              Access to over 200 live & on demand BFR workouts
                            </li>
                            <li className="py-1 text-md text-white">
                              Access to BFR masterclasses and educational series
                            </li>{" "}
                            <li className="py-1 text-md text-white">
                              Join a community focused on fitness, recovery &
                              motivation
                            </li>{" "}
                          </ul>
                          <p className="text-[#00adef] text-md text-white">
                            After 30 days, your subscription will automatically
                            renew at $29.99/month. Cancel anytime.
                          </p>
                          <p className="pt-2 text-[#00adef] mt-2 md:mt-0 text-2xl">
                            Please choose one to continue:
                          </p>
                          <div className="flex flex-col gap-2 mt-8 md:mt-4">
                            <label className="grid grid-cols-[1.25rem_auto] items-start gap-3 cursor-pointer">
                              <input
                                type="radio"
                                name="b3u-subscription"
                                className="w-4 h-4 mt-2 accent-[#00adef]"
                                checked={confirmSubscribe === true}
                                onChange={() => {
                                  setConfirmSubscribe(true);
                                  setHasSelected(true);
                                }}
                              />
                              <span className="text-md leading-6 text-white">
                                Yes, I want my{" "}
                                <strong>FREE 30-day B3 U trial</strong> and full
                                access to workouts, coaching, and community.
                              </span>
                            </label>

                            <label className="grid grid-cols-[1.25rem_auto] items-start gap-3 cursor-pointer">
                              <input
                                type="radio"
                                name="b3u-subscription"
                                className="w-4 h-4 mt-2 accent-[#00adef]"
                                checked={confirmSubscribe === false}
                                onChange={() => {
                                  setConfirmSubscribe(false);
                                  setHasSelected(true);
                                }}
                              />
                              <span className="text-md leading-6 text-white">
                                No, I do not want the Free 30 days on the{" "}
                                <strong>
                                  B<span className="text-[#00adef]">3</span> U
                                  Fitness App
                                </strong>{" "}
                                and future monthly subscriptions. I agree to
                                waive these benefits and do not need the
                                coaching, assistance, inspiration and
                                motivation.
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            </div>
          </div>
          <div className="text-center pt-0 block lg:hidden">
            <Button
              onClick={handleContinue}
              disabled={!hasSelected}
              className={`mx-auto !w-full text-base md:text-lg px-5 py-2 rounded-full font-light mt-0 lg:max-w-[300px] ${
                !hasSelected ? "opacity-50 cursor-not-allowed" : ""
              }`}
              data-mdb-ripple="true"
              data-mdb-ripple-color="light"
            >
              Continue
            </Button>
          </div>
          <div className="flex items-center justify-center mb-4 pt-10 w-full lg:w-1/3 hidden md:block">
            <Carousel
              className="!h-auto"
              swiperImages={["B3U1.png", "B3U2.png", "B3U3.png"]}
            />
            <div className="mt-2">
              <VideoModal
                open={isMobileVideo}
                setOpen={setIsMobileVideo}
                videoId="1045383546"
              />
            </div>
          </div>
        </div>
        <div className="text-center pt-0 hidden lg:block">
          <Button
            onClick={handleContinue}
            disabled={!hasSelected}
            className={`mx-auto !w-full text-base md:text-lg px-5 py-2 rounded-full font-light mt-2 lg:max-w-[300px] ${
              !hasSelected ? "opacity-50 cursor-not-allowed" : ""
            }`}
            data-mdb-ripple="true"
            data-mdb-ripple-color="light"
          >
            Continue
          </Button>
        </div>
      </div>
    </section>
  );
};

export default B3Member;
